import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, Award, Users, Leaf } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();

  const values = [
    { icon: Award, label: 'Qualidade Premium', color: 'text-orange-500' },
    { icon: Users, label: 'Atendimento Personalizado', color: 'text-blue-500' },
    { icon: Leaf, label: 'Sustentabilidade', color: 'text-emerald-500' },
    { icon: CheckCircle, label: 'Confiança', color: 'text-purple-500' }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-orange-100 text-orange-600 text-sm font-semibold rounded-full mb-4">
            {t('about.title')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('about.subtitle')}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-red-500 mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="/assets/about.webp"
                alt="Pigmentos Store"
                className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-orange-500/20 rounded-2xl -z-10" />
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-500/20 rounded-2xl -z-10" />
          </div>

          {/* Content Side */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('about.text1')}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('about.text2')}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t('about.text3')}
            </p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-3 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                  <value.icon className={`w-6 h-6 ${value.color}`} />
                  <span className="text-gray-700 font-medium">{value.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
